import { render, staticRenderFns } from "./ApplicationLoginOtp.vue?vue&type=template&id=163e4bf7&scoped=true&"
import script from "./ApplicationLoginOtp.vue?vue&type=script&lang=js&"
export * from "./ApplicationLoginOtp.vue?vue&type=script&lang=js&"
import style0 from "./ApplicationLoginOtp.vue?vue&type=style&index=0&id=163e4bf7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "163e4bf7",
  null
  
)

export default component.exports